import React from "react";
import PropTypes from "prop-types";
import { ResponsiveImage } from "@quintype/components";
import { withElementWrapper } from "../withElementWrapper";

import "./image.m.css";
import { clientWidth, shapeStory, shapeConfig, removeHtmlTags } from "../../../../utils/utils";
import { FullScreenImages } from "../../../Molecules/FullScreenImages";
import { useStateValue } from "../../../SharedContext";
import { CaptionAttribution } from "../../CaptionAttribution";
import { HyperLink } from "../../Hyperlink";

const ImageBase = ({ element, opts = {}, story = {}, config = {}, caption = true, aspectRatio, ...restProps }) => {
  if (!element) return null;
  const configData = useStateValue() || {};
  const [mobileAspectRatio, desktopAspectRatio = mobileAspectRatio] = aspectRatio;
  const isMobile = clientWidth("mobile");
  const imageAspectRatio = isMobile ? mobileAspectRatio : desktopAspectRatio;

  const getPadding = (aspectRatio) => {
    const [height, width] = aspectRatio;
    if (height > 0 && width > 0) {
      const padding = (width / height) * 100;
      return padding;
    }
    return 0;
  };

  const imagePadding = isMobile ? getPadding(mobileAspectRatio) : getPadding(desktopAspectRatio);

  const ImageTemplate = ({ onClick }) => (
    <div styleName="image-template" className="image-template">
      <figure styleName="element" style={{ paddingTop: imagePadding + `%` }}>
        <ResponsiveImage
          slug={element["image-s3-key"]}
          metadata={element["image-metadata"]}
          alt={removeHtmlTags(element["alt-text"] || element.title)}
          title={removeHtmlTags(element["alt-text"] || element.title)}
          aspectRatio={imageAspectRatio}
          defaultWidth={640}
          widths={opts.imageWidths || [360, 640]}
          imgParams={{ auto: ["format", "compress"], q: 70 }}
          shouldDecodeImage={true}
        />
      </figure>
      {element.hyperlink && <HyperLink hyperLink={element.hyperlink} />}
    </div>
  );

  ImageTemplate.propTypes = {
    onClick: PropTypes.func,
  };

  return (
    <div className="arrow-component arr--image-element" {...restProps} data-test-id="image-element">
      <FullScreenImages template={ImageTemplate} element={element} imageSlug={element["image-s3-key"]} story={story} />
      {caption && <CaptionAttribution element={element} config={configData} isStoryCaption />}
    </div>
  );
};

ImageBase.propTypes = {
  element: PropTypes.shape({
    "image-s3-key": PropTypes.string,
    "image-metadata": PropTypes.object,
    "image-attribution": PropTypes.string,
    title: PropTypes.string,
    hyperlink: PropTypes.string,
  }),
  caption: PropTypes.bool,
  opts: PropTypes.shape({ imageWidths: PropTypes.array }),
  story: shapeStory,
  config: shapeConfig,
  aspectRatio: PropTypes.array,
};

ImageBase.defaultProps = {
  aspectRatio: [[16, 9]],
};

export const Image = withElementWrapper(ImageBase);
